'use client';

import React, { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

type ImpressionTrackerProps = {
    onImpression: () => Promise<void>;
};

const ImpressionTracker: React.FC<ImpressionTrackerProps> = ({ onImpression }) => {
    const { ref, inView } = useInView();
    useEffect(() => {
        if (inView) {
            onImpression().then();
        }
    }, [inView, onImpression]);
    return <div ref={ref} />;
};

export default ImpressionTracker;
